var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TagType } from '@common/api';
import { useTagContext } from '@data/tag/tagContext';
import Tags from '@shared/tags/Tags';
import { ModelTitleBar, ModelTitleBarTags } from '@styled/Model';
import React from 'react';
import { FeatureWrapper } from '../../base/FeatureWrapper';
import { useLanguage } from '../../base/LanguageProvider';
import { useUpdateSheetRow } from '../../data/sheetRow/sheetRowActions';
import { useTagActions } from '../../data/tag/tagActions';
import { isAccountTag, isDimensionTag } from '../../data/tag/types';
var TitleBarComponent = function (_a) {
    var expandedSelectedSheetRow = _a.expandedSelectedSheetRow;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var createTag = useTagActions().createTag;
    var updateSheetRow = useUpdateSheetRow();
    var makeTag = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        var tagExists, newTag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tagExists = !!tagData.getTagByNameAndParent(name, null);
                    if (tagExists) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createTag({ name: name, ParentId: null, description: '' })];
                case 1:
                    newTag = _a.sent();
                    if (!newTag) {
                        return [2 /*return*/];
                    }
                    updateSheetRow.mutate(__assign(__assign({}, expandedSelectedSheetRow.sheetRow), { dimensionTagIds: __spreadArray(__spreadArray([], __read(expandedSelectedSheetRow.sheetRow.dimensionTagIds), false), [newTag.id], false) }));
                    return [2 /*return*/];
            }
        });
    }); };
    var selectTag = function (tagId) {
        var tag = tagData.tagById[tagId];
        if (!tag) {
            return;
        }
        updateSheetRow.mutate(__assign(__assign({}, expandedSelectedSheetRow.sheetRow), { accountTagId: isAccountTag(tag) ? tag.id : expandedSelectedSheetRow.sheetRow.accountTagId, dimensionTagIds: isDimensionTag(tag)
                ? __spreadArray(__spreadArray([], __read(expandedSelectedSheetRow.sheetRow.dimensionTagIds), false), [tag.id], false) : expandedSelectedSheetRow.sheetRow.dimensionTagIds }));
    };
    var removeTag = function (tagId) {
        var tag = tagData.tagById[tagId];
        if (!tag) {
            return;
        }
        updateSheetRow.mutate(__assign(__assign({}, expandedSelectedSheetRow.sheetRow), { accountTagId: isAccountTag(tag) ? null : expandedSelectedSheetRow.sheetRow.accountTagId, dimensionTagIds: isDimensionTag(tag)
                ? expandedSelectedSheetRow.sheetRow.dimensionTagIds.filter(function (id) { return id !== tagId; })
                : expandedSelectedSheetRow.sheetRow.dimensionTagIds }));
    };
    var accountTags = [];
    var dimensionTags = [];
    expandedSelectedSheetRow === null || expandedSelectedSheetRow === void 0 ? void 0 : expandedSelectedSheetRow.allTags.forEach(function (t) {
        var tag = tagData.tagById[t.id];
        if (tag) {
            tag.type === TagType.Account ? accountTags.push(tag) : dimensionTags.push(tag);
        }
    });
    var inheritedTags = expandedSelectedSheetRow === null || expandedSelectedSheetRow === void 0 ? void 0 : expandedSelectedSheetRow.allTags.filter(function (t) { return t.inherited === true; });
    return (React.createElement(ModelTitleBar, null,
        React.createElement(FeatureWrapper, { featureKey: "canSeeTagsInModel" },
            React.createElement(ModelTitleBarTags, null,
                React.createElement("div", { style: { flexGrow: 1, display: 'flex', alignItems: 'center' } },
                    React.createElement(Tags, { tags: accountTags, canUpdate: true, select: selectTag, remove: removeTag, singleLine: true, inheritedTags: inheritedTags, filterByTypes: [TagType.Account], afterButtonLabel: L('Variable'), afterButtonLabelType: TagType.Account })),
                React.createElement(Tags, { tags: dimensionTags, canUpdate: true, create: makeTag, select: selectTag, remove: removeTag, singleLine: true, inheritedTags: inheritedTags, filterByTypes: [TagType.Dimension], afterButtonLabel: L('Dimension'), afterButtonLabelType: TagType.Dimension })))));
};
export default TitleBarComponent;
